module.exports = __webpack_public_path__ + "static/media/avatar-300.0aba0a1c.png";